import React from 'react';
import { Icon } from 'semantic-ui-react';
// import { connect } from 'react-redux';
// import { withRouter } from 'react-router';

// import * as actions from '../actions';

const styles = {
	datePosted: {
		color: 'grey',
		fontSize: '1.5em',
		marginLeft: '-15px',
	},
	title: {
		color: 'black',
		marginTop: '10px',
		marginBottom: '10px',
	},
	meta: {
		color: 'steelblue',
		fontSize: '2em',
	},
};

const BlogTitle = ({ datePosted, meta, title }) => {
	return (
		<div className="col-12 text-left mb-5">
			<div style={styles.datePosted} className="col">
				<div className="pb-2 pr-3">
					<Icon name="calendar alternate outline" /> {datePosted}
				</div>
				<div className="pb-2">
					<Icon name="user" /> George Kanchev
				</div>
			</div>
			<h1 style={styles.title}>{title}</h1>
			<div style={styles.meta}>{meta}</div>
		</div>
	);
};

// function mapStateToProps(state) {
// 	return {};
// }

// export default withRouter(
// 	connect(
// 		mapStateToProps,
// 		actions,
// 	)(BlogItem),
// );
export default BlogTitle;



// WEBPACK FOOTER //
// ./src/components/common/BlogTitle.js